module.exports = __webpack_public_path__ + "img/jameson-logo-age-confirm.ff4af69a.svg";